/**
 * Dot data for the listing mini-map, in a module of its own: importing
 * these from ListingMiniMap pulled MapLibre (~1 MB) into the page that
 * only wanted the colours.
 */
export type MapDot = { lat: number; lng: number; tone?: "deal" | "fair" | "over" | null };

/** Explicit hexes: a dot sits on the map picture in both themes. */
export const DOT_TONE: Record<string, string> = { deal: "#059669", fair: "#d97706", over: "#e11d48", none: "#64748b" };
